<template>
    <sub-page class="exam-detail">
        <el-row :gutter="20">
            <el-col :span="6">
                <ui-card class="exam-panel exam-info" :title="$t('count.countAnalysis')"
                         icon="nucfont inuc-list-chart">
                    <ul>
                        <li><h3>直播名称：</h3>
                            <p>{{liveDetail.name}}</p></li>
                        <li><h3>开始时间：</h3>
                            <p>{{liveDetail.beginTime}}</p></li>
                        <li><h3>结束时间：</h3>
                            <p>{{liveDetail.endTime}}</p></li>
                        <li><h3>主播名称：</h3>
                            <p>{{liveDetail.userName}}</p></li>
                        <li><h3>参与人数：</h3>
                            <p>{{liveDetail.viewers}}</p></li>
                        <li><h3>评论数量：</h3>
                            <p>{{liveDetail.comments}}</p></li>
                        <li><h3>是否开启密码：</h3>
                            <p>{{liveDetail.isPassword ? '是' : '否'}}</p></li>
                        <li><h3>直播公告：</h3>
                            <p>{{liveDetail.notice}}</p></li>
                    </ul>
                    <div class="count-score" v-if="false">
                        <p>总评分：{{liveDetail.totalScore}}</p>
                        <p>评分人数：{{liveDetail.totalNumber}}</p>
                        <p>平均分：
                            <el-rate
                                v-model="liveDetail.avgScore"
                                disabled
                                show-score
                                text-color="#ff9900"
                                score-template="{value}">
                            </el-rate>
                        </p>
                    </div>
                </ui-card>
            </el-col>
            <el-col :span="18">
                <ui-card class="exam-panel paper-score-statistic" title="直播统计"
                         icon="nucfont inuc-bar-chart">
                    <div v-for="(item,index) in items" :key="index" style="position: relative">
                        <span class="exam-chart-title">{{item.titleName}}</span>
                        <statistics-upload-top
                            :ref="item.id"
                            :statisticName="item.titleName"
                            :id="item.id"
                            :sourceType="sourceType"
                            :legendName="item.legendName">
                        </statistics-upload-top>
                    </div>
                </ui-card>
            </el-col>
        </el-row>

        <div class="ibox">
            <div class="content-header">
                <div class="header-icon">
                    <i class="nucfont inuc-menu-assemble"></i>
                </div>
                <span class="title">观看学员</span>
                <div class="btn-box">
                    <a :href="href" ref="downLoad" id="export-a"></a>
                    <el-tooltip class="item" effect="dark" content="导出直播记录"
                                placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" class="btn" @click="exportLiveRecord('ruleCard')">
                            <i class="nucfont inuc-daochu"></i>
                        </el-button>

                    </el-tooltip>
                </div>
            </div>
            <div class="content_detail">
                <el-form :inline="true" size="mini" style="padding: 10px">
                    <el-form-item :label="$t('c.username')">
                        <el-input v-model="formSearch.search" placeholder="请输入学员姓名或账号"
                                clearable></el-input>
                    </el-form-item>
                    <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
                    <el-form-item>
                        <el-button type="primary" @click="getUserAndComment" round>{{$t('c.query')}}</el-button>
                    </el-form-item>
                </el-form>
                <el-row :gutter="20">
                    <el-col :span="16">
                        <data-tables :data="studentData"
                                    :table-props="tableProps"
                                    :current-page.sync="currentPage"
                                    :page-size="20"
                                    :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                                    header-align="center"
                                    class="live-student-table"
                        >
                            <el-table-column type="index" width="40" align="center">
                            </el-table-column>
                            <el-table-column v-for="(title, index) in studentTitles" :prop="title.prop"
                                            :label="title.label"
                                            :key="index"
                                            :width="title.width"
                                            show-overflow-tooltip
                                            sortable="custom"
                                            align="center"
                                            class="table-title">
                            </el-table-column>
                            <el-table-column property="duration" label="观看总时长" align="center" sortable>
                                <template slot-scope="scope">
                                    {{getHMSTime(scope.row.duration)}}
                                </template>
                            </el-table-column>
                            <el-table-column property="comments" label="评论总次数" align="center"
                                 show-overflow-tooltip sortable></el-table-column>
                        </data-tables>
                    </el-col>
                    <el-col :span="8">
                        <div class="room-right">
                            <div class="room-aside">
                                <div class="room-desc">
                                    聊天记录
                                </div>
                                <div class="room-message">
                                    <ul class="comment-list">
                                        <li class="comment-item" v-for="item in commentList" :key="item.id">
                                            <p class="user-time">
                                                <span class="user">{{item.userName}}</span>
                                                <span class="time">{{item.createLocalTime}}</span>
                                            </p>
                                            <p class="content">{{item.content}}</p>
                                        </li>
                                        <p v-show="!pagTotal" class="emptyBox">
                                            {{$t('c.noData')}}
                                        </p>
                                    </ul>

                                </div>
                                <div class="pagination-bar">
                                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                                                :current-page="currentComPage" :page-sizes="[20, 50, 100, 300, 500]"
                                                :page-size="pageCommentSize"
                                                layout="prev, pager, next,total " :total="pagTotal">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>


        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @updateData="query"></router-view>
        </transition>

    </sub-page>
</template>

<script>
    import api from '@/api';
    import SubPage from '@/components/Subpage';
    import SelectMultiOrgs from '@/components/SelectMultiOrgs';
    import uiCard from '@/components/Statistics/StatisticUICard.vue';
    import StatisticsUploadTop from "@/components/Statistics/StatisticsUploadTop";
    import StatisticsKnowledgeRate from "@/components/Statistics/StatisticsKnowledgeRate";
    import {Ticket} from '@/utils';
    import SelectMultiple from '@/components/Selectmultiple';

    export default {
        data() {
            return {
                liveID: this.$route.params.liveID,
                liveDetail: {
                    name: '',
                    beginTime: '',
                    endTime: '',
                    userName: '',
                    viewers: '',
                    comments: '',
                    isPassword: false,
                    notice: '',
                    totalScore: '',
                    totalNumber: '',
                    avgScore: '',
                },
                items: [
                    {
                        titleName: '观看时长统计',
                        id: 'viewer',
                        legendName: '秒'
                    },
                    {
                        titleName: '评论数量统计',
                        id: 'comment',
                    }
                ],
                sourceType: undefined,
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "606px"
                },
                //学员成绩排名
                formSearch: {
                    search: undefined,
                    orgIds: []
                },
                studentData: [],
                currentPage: 1,
                currentCommentPage: 1,
                pageCommentSize:20,
                pagTotal: 0,
                studentTitles: [{
                    prop: 'name',
                    label: this.$t('c.username')
                }, {
                    prop: 'account',
                    label: this.$t('c.account')
                }, {
                    prop: 'orgName',
                    label: this.$t('c.belong')
                },
                // {
                //     prop: 'duration',
                //     label: '观看总时长'
                // }, {
                //     prop: 'comments',
                //     label: '评论总次数'
                // }
                ],

                href: undefined,
                commentList: [],
            }
        },
        created() {
            if (Ticket.get()) {
                this.userInfo = Ticket.get();
            }

            this.getliveDetails();
            this.getViewerRank();
            this.getCommentRank();
            this.getLiveStudents();
            this.getLiveComments(1);

        },
        methods: {
            //查询观看学员和聊天记录
            getUserAndComment(){
                this.getLiveStudents();
                this.getLiveComments(1);
            },

            uploadFunction(data, id) {
                // 父组件多次同一个子组件，调用子组件函数时应加上唯一的标识（id）
                this.$refs[id][0].upLoadSeption(data, id);
            },
            getliveDetails() {

                api.getLivingDetailStatistic(this.liveID).then(res => {
                    if (res.package) {
                        for (let item in this.liveDetail) {
                            this.liveDetail[item] = res.package[item]
                        }
                    }
                })
            },
            getViewerRank() {
                //成绩直方图
                let data = {
                    limit: 10
                };
                api.getLiveTopViewers(this.liveID,data).then(res => {
                    if (res.package) {
                        this.uploadFunction(res.package, 'viewer')
                    } else {
                        this.uploadFunction([])
                    }
                })
            },
            getCommentRank() {
                //成绩分布直方图
                let data = {
                    limit: 10
                };
                api.getLiveTopComment(this.liveID,data).then(res => {
                    if (res.package) {
                        this.uploadFunction(res.package, 'comment')
                    } else {
                        this.uploadFunction([])
                    }
                })
            },
            getLiveStudents() {
                this.currentPage = 1;
                let data = {...this.formSearch};
                api.getLivingUserStatistic(this.liveID,data).then(res => {
                    if (res.package) {
                        this.studentData = res.package;
                        // this.studentData.forEach(item => {
                        //     item.duration = this.getHMSTime(item.duration)
                        // });
                    }
                })
            },
            getLiveComments(type) {
                if(type==1){
                    this.currentCommentPage = 1;
                }
                let data = {
                    pageNo: this.currentCommentPage,
                    limit: this.pageCommentSize,
                    ...this.formSearch};
                api.getLivingCommentStatistic(this.liveID,data).then(res => {
                    if (res.package) {
                        this.commentList = res.package;
                    }
                    this.pagTotal = res.total;
                })
            },
            //直播记录导出
            exportLiveRecord(formName) {
                const ticket = Ticket.get().access_token;
                const culture = this.$i18n.locale;
                this.href = `${APIURI}/api/live/statistics/LiveRecordExport/${this.liveID}?access_token=${ticket}&culture=${culture}&ui-culture=${culture}`;
                this.$nextTick(() => {
                    $('#export-a')[0].click();
                });
            },
            handleCurrentChange(val) {
                this.currentCommentPage = val;
                this.getLiveComments(val);
            },
            orgsChange(data) {
                this.formSearch.orgIds = data;
            },
            getHMSTime (second_time) {
                var time = second_time + "秒";
                if( second_time > 60){
                    var second = parseInt(second_time) % 60;
                    var min = parseInt(second_time / 60);
                    time = min + "分钟" + second + "秒";
                    if( min > 60 ){
                        min = parseInt(second_time / 60) % 60;
                        var hour = parseInt( parseInt(second_time / 60) /60 );
                        time = hour + "小时" + min + "分钟" + second + "秒";
                        if( hour > 24 ){
                            hour = parseInt( parseInt(second_time / 60) /60 ) % 24;
                            var day = parseInt( parseInt( parseInt(second_time / 60) /60 ) / 24 );
                            time = day + "天" + hour + "小时" + min + "分钟" + second + "秒";
                        }
                    }
                }
                return time
            },


        },

        components: {
            SubPage,
            uiCard,
            StatisticsUploadTop,
            // paperView,
            SelectMultiple,
            StatisticsKnowledgeRate,
            SelectMultiOrgs
        }
    }
</script>

<style scoped lang="scss">
    @import '~@/style/const.scss';
    .live-student-table{
        border: 1px solid #e5e4e4;
    }
    .exam-detail {
        & /deep/ .ibox {
            .content_detail {
                .resource-type {
                    .knowledgeBox {
                        width: 700px;
                        min-width: 700px;
                    }
                }
                .el-select-dropdown__list {
                    min-width: 150px;
                }
            }
        }
        & /deep/ .ui-card {
            border: 1px solid #ebebed;
            box-shadow: none;
            .card-header {
                border-bottom: 1px solid #ebebed;
            }
        }
        @media screen and (max-width: 1280px) {
            .el-col {
                float: none;
                width: 100%;
            }
            .exam-info {
                height: 500px;
            }
            .ibox .content_detail {
                padding: 0;
            }
        }
    }

    .exam-info {
        height: 732px;
        & /deep/ .card-body {
            padding: 0;
        }
    }

    .exam-panel {
        ul {
            width: 100%;
            padding: 0 20px 5px 20px;

            li {
                display: flex;
                padding: 15px 0;
                border-bottom: 1px dashed #cccdcd;
                &:last-child {
                    border-bottom: none;
                }
            }
            h3 {
                display: inline-block;
                min-width: 90px;
            }
            p {
                flex: 1;
            }
        }

        .count-score {
            padding: 5px 20px 0 20px;
            border-top: 1px solid #dedede;
            p {
                padding: 15px 0;
                border-bottom: 1px dashed #cccdcd;
            }
            .el-rate {
                display: inline-block;
            }
        }
    }

    .paper-score-statistic {
        & /deep/ .content-header {
            display: none;
        }
        & /deep/ .ibox {
            box-shadow: none;
            .el-card__body {
                padding: 0 0;
            }
            .content_detail {
                padding: 0;
                .resource-type {
                    .knowledgeBox {
                        height: 290px;
                    }
                    .emptyBox {
                        height: 290px;
                        line-height: 290px;
                    }
                }
            }
        }
        .exam-chart-title {
            display: inline-block;
            margin: 15px 40px 0;
            padding: 2px 5px;
            color: #fff;
            font-size: 14px;
            background: #2f80ad;
            letter-spacing: 1px;
        }
    }

    .ibox {
        background-color: #fff;
        border: 1px solid #ebebed;
        box-shadow: none;
        .content-header {
            height: 40px;
            background: #f4f3f8;
            border-bottom: 1px solid #ebebed;
            .btn-box {
                float: right;
                .btn {
                    background: #f3f6f6;
                    border: none;
                    color: #208acc;
                }
            }
            .header-icon {
                display: inline-block;
                height: 40px;
                width: 45px;
                line-height: 40px;
                text-align: center;
                border-right: 1px solid #ccc;
                box-shadow: 1px 0 0 #fff;
                color: #2e7faa;
                .nucfont {
                    font-size: 20px
                }
            }
            .title {
                height: 40px;
                line-height: 40px;
                padding-left: 10px;
                color: #333;
                font-size: 18px;
            }
        }
        .content_detail {
            padding: 15px;
        }
    }

    .exam-detail {
        > /deep/ .el-main {
            overflow-x: hidden;
        }
    }
    .room-right {
        // position: absolute;
        // top: 0;
        // right: 0;
        // bottom: 0;
        width: 100%;
        // height:662px;
        border: 1px solid #e5e4e4;
        // border-radius: 4px;
    }

    .room-aside {
        display: flex;
        flex-direction: column;
        height: 100%;

        .room-desc {
            // padding: 8px 10px;
            height: 46px;
            line-height: 46px;
            padding-left: 15px;
            font-weight: bold;
            font-size: 15px;
            color: #4d4d4d;
            border-bottom: 1px solid #e5e4e4;
            background-color: #f8f8f8;
        }

        .room-message {
            padding: 10px 10px 0 10px;
            height: 560px;
            // flex: 1;
            overflow: auto;
            .emptyBox{
                color: #909399;
                text-align: center;
                line-height: 540px;
            }
        }
    }
    .pagination-bar{
        height: 54px;
        border-top: 1px solid #e5e4e4;
    }

    .comment-list {
        .comment-item {
            word-break: break-all;
            + .comment-item {
                margin: 6px 0;
            }
            >p{
                line-height: 26px;
            }
        }

        // .user, .content {
        //     font-size: 13px;
        // }

        .user {
            color: $color-theme;
            padding-right: 15px;
            // font-weight: bold;
        }
        .time{
            color: #999;
            font-size: 12px;
        }

        .self {
            color: #ff5d23;
        }
    }
</style>
